import { getLogger } from '@vf/services/LoggingService';
import { ContactFlow, PhoneNumberSummary, PromptSummary } from 'aws-sdk/clients/connect';
import { HelperApi, ConnectQueue } from '@voicefoundry-cloud/vf-omp-shared';
import { ApiClientBase } from './ApiClientBase';

export class HelpersApiClient extends ApiClientBase implements HelperApi {
  constructor(apiUrl: string, useAuth: boolean) {
    super(apiUrl, getLogger('HelpersApiClient'), useAuth);
  }

  async getAllQueues(): Promise<ConnectQueue[]> {
    const result = await this.get('/api/helpers/queues');
    return (await result.json()).sort((a: ConnectQueue, b: ConnectQueue) => a.Name.localeCompare(b.Name));
  }
  async getAllFlows(): Promise<ContactFlow[]> {
    const result = await this.get('/api/helpers/flows');
    return await result.json();
  }
  async getAllPrompts(): Promise<PromptSummary[]> {
    const result = await this.get('/api/helpers/prompts');
    return await result.json();
  }
  async getAllNumbers(): Promise<PhoneNumberSummary[]> {
    const result = await this.get('/api/helpers/numbers');
    return await result.json();
  }
  async getAllTimezones(): Promise<string[]> {
    const result = await this.get('/api/helpers/timezones');
    return await result.json();
  }
}
